import React, { createContext, useContext, useState } from 'react';

const NotificationContext = createContext(null);

let idCounter = 1;

export const NotificationProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const remove = (id) => {
    setToasts((prev) => prev.map((t) => (t.id === id ? { ...t, leaving: true } : t)));
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, 280);
  };

  const push = (level, title, message, duration = 4500) => {
    const id = idCounter++;
    setToasts((prev) => [...prev, { id, level, title, message, leaving: false }]);
    if (duration > 0) {
      setTimeout(() => remove(id), duration);
    }
    return id;
  };

  const api = {
    success: (title, message, duration) => push('success', title, message, duration),
    error:   (title, message, duration) => push('error',   title, message, duration ?? 6000),
    warn:    (title, message, duration) => push('warn',    title, message, duration),
    info:    (title, message, duration) => push('info',    title, message, duration),
    remove
  };

  return (
    <NotificationContext.Provider value={{ toasts, ...api }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotify = () => {
  const ctx = useContext(NotificationContext);
  if (!ctx) throw new Error('useNotify must be used inside NotificationProvider');
  return ctx;
};
